import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { TypedMemo } from '../../../common/types';
import { LoadingView } from '../../../common/views/LoadingView';
import { useAccountId } from '../../../../redux/slices/appInfo/hooks';
import { InboxScreen } from './InboxScreen';

/** The routes `/outreach/inbox` and `/outreach/inbox/:replyUuid` (design outreach g1). */
const InboxViewComponent: React.FC = () => {
  const accountId = useAccountId();
  const { replyUuid } = useParams<{ replyUuid?: string }>();
  const [searchParams] = useSearchParams();
  if (accountId === null) {
    return <LoadingView />;
  }
  return (
    <InboxScreen accountId={accountId} replyUuid={replyUuid ?? null} initialCampaign={searchParams.get('campaign')} />
  );
};

export const InboxView = TypedMemo(InboxViewComponent);
